import { useState } from "react";
import styled from "styled-components";
import { PreviewContainer, Title, TitleRow, TopRow } from "routes/createContent/components/styles";
import Counter from "routes/createContent/components/Counter";
import parseHTML from "utils/parseHtml";

type ParsedContent = {
  type: string;
  content: string;
}[];

interface Props {
  lesson: any;
}

export const LessonPreview: React.VFC<Props> = ({ lesson }) => {
  const [currentPart, setCurrentPart] = useState(1);
  const selectedPart = lesson?.parts[currentPart - 1];

  const { order, translation } = selectedPart;

  const parsedContent: ParsedContent = JSON.parse(translation.content);
  const hasMoreThanOnePart = lesson?.parts.length > 1;

  return (
    <div>
      <h1>Lesson</h1>
      <p>Details of the lesson will be displayed here.</p>

      <PreviewContainer>
        {hasMoreThanOnePart && (
          <TopRow>
            <Counter
              value={currentPart}
              maxValue={lesson?.parts.length ?? 1}
              minValue={1}
              clickCallback={newPart => setCurrentPart(newPart)}
            />
          </TopRow>
        )}

        <TitleRow>
          <Title>
            {translation.title} {order}
          </Title>
        </TitleRow>

        {parsedContent &&
          parsedContent.map(({ type, content }, index: number) => {
            const key = `${lesson.name}-${order}-${index}`;
            switch (type) {
              case "heading":
                return <Header key={key}>{content}</Header>;
              case "paragraph":
                return <Body key={key} dangerouslySetInnerHTML={{ __html: parseHTML(content) }} />;
              case "image":
                return <Image key={key} src={content} alt={translation.title} />;
              default:
                return null;
            }
          })}
      </PreviewContainer>
    </div>
  );
};

const Header = styled.h3`
  ${props => props.theme.font.header3};
  color: ${props => props.theme.colors.base};
  margin-bottom: 10px;
`;

const Body = styled.span`
  ${props => props.theme.font.body1}
  color: ${props => props.theme.colors.base};
  white-space: pre-wrap;
`;

const Image = styled.img`
  width: 100%;
`;
